import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from './translation.service';

@Pipe({ name: 'translate', standalone: true, pure: false })
export class TranslatePipe implements PipeTransform {
  private svc = inject(TranslationService);

  transform(key: string): string {
    return this.svc.translate(key);
  }
}
